// extracted by mini-css-extract-plugin
export default {"container":"AddComment_container__+dHp5","profilePhoto":"AddComment_profilePhoto__AYw5E"};